import { render, staticRenderFns } from "./ThreadEntry.vue?vue&type=template&id=16963d4a&scoped=true"
import script from "./ThreadEntry.vue?vue&type=script&setup=true&lang=ts"
export * from "./ThreadEntry.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ThreadEntry.vue?vue&type=style&index=0&id=16963d4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16963d4a",
  null
  
)

export default component.exports